import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";

import { IncidenciaSeguridad } from "../../shared/model/iso42001/incidencia-seguridad.model";

export interface RegresarProcesoSeguridadDialogData {
  incidencia?: IncidenciaSeguridad | null;
  accion?: "regresar" | "cancelar";
}

@Component({
  selector: "app-regresar-proceso-seguridad-dialog",
  standalone: true,
  templateUrl: "./regresar-proceso-seguridad-dialog.component.html",
  styleUrls: ["./regresar-proceso-seguridad-dialog.component.css"],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
  ],
})
export class RegresarProcesoSeguridadDialogComponent {
  comentario = "";
  error = "";

  get esCancelacion(): boolean {
    return this.data?.accion === "cancelar";
  }

  get titulo(): string {
    return this.esCancelacion ? "Cancelar incidencia" : "Regresar a proceso";
  }

  get descripcion(): string {
    return this.esCancelacion
      ? "Captura el motivo por el que no corresponde tratarla como incidencia de seguridad"
      : "Captura el motivo para regresar la incidencia a proceso";
  }

  get etiquetaComentario(): string {
    return this.esCancelacion ? "Motivo de cancelación" : "Comentario";
  }

  get placeholder(): string {
    return this.esCancelacion
      ? "Describe por qué se cancela la incidencia"
      : "Describe el motivo para regresar la incidencia a proceso";
  }

  get textoBoton(): string {
    return this.esCancelacion ? "Guardar y cancelar" : "Guardar y regresar";
  }

  get iconoBoton(): string {
    return this.esCancelacion ? "cancel" : "undo";
  }

  constructor(
    private dialogRef: MatDialogRef<RegresarProcesoSeguridadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RegresarProcesoSeguridadDialogData,
  ) {}

  cerrar(): void {
    this.dialogRef.close({ cancelled: true });
  }

  confirmar(): void {
    if (!this.comentario.trim()) {
      this.error = this.esCancelacion
        ? "Agrega un motivo antes de cancelar la incidencia."
        : "Agrega un comentario antes de regresar a proceso.";
      return;
    }
    this.dialogRef.close({ confirmed: true, comentario: this.comentario.trim() });
  }
}
